import { Component, OnInit, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { FaqService } from '@fuse/services/faq/faq.service';
import { TranslateService } from '@ngx-translate/core';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { CompanyService } from '@fuse/services/company.service';
import { fuseAnimations } from '@fuse/animations';
import { FormControl } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { FaqAnswerComponent } from './dialogs/answer.component';

@Component({
    selector: 'faq',
    templateUrl: './faq.component.html',
    styleUrls: ['./faq.component.scss'],
    animations: fuseAnimations
})
export class FaqComponent implements OnInit, OnDestroy {
    searchInput: FormControl;
    faq: any;
    group: any;
    faqs = [];
    lang = 'sr';
    company = { id: null, name: null, chat_token: null };

    private _unsubscribeAll: Subject<any>;

    constructor(
        private _faqService: FaqService,
        private _matDialog: MatDialog,
        private _translate: TranslateService,
        private _translationLoader: FuseTranslationLoaderService,
        private _companyService: CompanyService,
    ) {
        this.searchInput = new FormControl('');
        this._unsubscribeAll = new Subject();
    }

    ngOnInit(): void {

        this.getTranslations();
        this._translationLoader.onLangChanged
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(value => {
                this.getTranslations();
            });

        this._companyService.onCompanyChanged
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((response) => {

                if (this.company.id !== this._companyService.activeCompany.id ? this._companyService.activeCompany.id : response.id) {
                    this.company = this._companyService.activeCompany;
                    this.getFaqs();
                }

            });

    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    /**
     * Read answer
     *
     * @param answer
     */
    readAnswer(answer): void {
        this._matDialog.open(FaqAnswerComponent, {
            panelClass: 'faq-answer-dialog',
            data: { answer: answer }
        });
    }

    getTranslations(): void {
        this._translationLoader.getLastLang()
            .then(response => {
                this.lang = response['code'];
                this._translationLoader.getTranslations(this.lang, '4');
            })
            .catch(err => Promise.reject(err))
            .then(() => {
            }, err => {
            });
    }

    getFaqs(): void {
        this._faqService.getFaqGroups(this.company.id)
            .then(response => {
                this.faqs = [];
                this.faqs.length = 0;
                this.group = [];
                this.group = response;
                Object.keys(this.group).forEach((key) => {
                    if (key !== '') {
                        let element = {};
                        this._faqService.getFaqsForGroup(this.company.id, key).then(response1 => {
                            const temp = [];
                            this.faq = [];
                            const language = [];
                            this.faq = response1.data;
                            this.faq.forEach((value) => {
                                let content = [];
                                content = value.content;
                                content.forEach((val) => {
                                    if (val.question !== '' && val.answer !== '') {
                                        let item = {};
                                        item = {
                                            question: val.question,
                                            answer: val.answer,
                                            lang: val.lang
                                        };
                                        temp.push(item);                                        
                                        language.push(val.lang);

                                    }
                                });
                            });

                            element = {
                                group: response1.data[0].group,
                                questions: temp,
                                languages: language
                            };
                            if (element['questions'].length) {
                                this.faqs.push(element);
                            }
                        })
                            .catch(err => Promise.reject(err))
                            .then(() => {
                            }, err => {
                            });
                    }
                });
                
            })
            .catch(err => Promise.reject(err))
            .then(() => {
                console.log(this.faqs);
            }, err => {
            });


    }
}
